import React, { useEffect, useState } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import Wrapper from "../../Common/FilterWrapper/index";

import { Grid } from "../../../components/Grid.components";
import { Boxed } from "../../../components/Boxed.components";
import {
  AsyncSelect,
} from "../../../components/Input.components";
import { Text } from "../../../components/Text.components";
import { Avatar } from "../../../components/Avatar.components";
import { Button } from "../../../components/Button.components";
import { Loader } from "../../../components/Loader.components";
import { EmptyState } from "../../../components/EmptyState.components";
import {
  TableComponent,
  PaginationComponent,
} from "../../../components/Table.components";
import {
  PageTitle,
  Icon,
  StyledDrpDown,
  DropDownMenu,
  DropDownButton,
} from "../../../components/style";

import { calcViewMode, formatDate, formatDateTime } from "../../../utils/utils";
import { pageOptions } from "../../../utils/constant";
import { Theme } from "../../../utils/theme";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import ExportReport from "./ExportReport/index";


export const RequestBreakdown = (props) => {
  // state props
  const {
    fetchActionURL,
    reportListTotal,
    isLoading,
    reportList,
    exportReportModal,
  } = props;

  // dispatch props
  const {
    getAllRequests,
    openExportModal,
    redirect,
    form: { getFieldProps },
  } = props;

  const [value, onChange] = useState([]);
  const [status, setStatus] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const dateChange = (val) => {
    const start = val[0].toISOString().slice(0, 10);
    const end = val[1].toISOString().slice(0, 10);
    setStartDate(start);
    setEndDate(end);
    onChange(val);
  };

  useEffect(() => {
    let data = {
      page: 1,
      limit: 10,
    };
    getAllRequests(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log({ reportList });
  //  console.log(filteredKeywords)
  const columns = [
    {
      title: "Created by",
      dataIndex: "firstName",
      key: "firstName",
      render: (text, record) => (
        <Avatar
          src={record?.createdBy?.profilePictureUrl}
          size={"38px"}
          name={`${record?.createdBy?.firstName} ${record?.createdBy?.lastName}`}
        />
      ),
    },
    {
      title: "Request Title",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <Boxed>
          {record?.requestTitle?.title}
          <br />
        </Boxed>
      ),
    },

    {
      title: "Creation Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => text && formatDateTime(text),
    },

    {
      title: "Last updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => text && formatDateTime(text),
    },
    {
      title: "Request Status",
      dataIndex: "email",
      key: "email",
      render: (text, record) => (
        <Boxed>
          {record?.status} <br />
        </Boxed>
      ),
    },
  ];
  // const hideDate = (event) => {
  //   event.stopPropagation();
  //   setShowDate(false);
  // };

  const externalParams = {};
  status && (externalParams["status"] = status);
  startDate && (externalParams["startDate"] = startDate);
  endDate && (externalParams["endDate"] = endDate);

  // console.log({reportListTotal});

  const statusList = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Open",
      value: "open",
    },
    {
      label: "Approved",
      value: "approved",
    },
    {
      label: "Change-requested",
      value: "change-requested",
    },
    {
      label: "Declined",
      value: "declined",
    },
  ];
  return (
    <>
      {/* <Boxed pad="20px" onClick={showDate ? hideDate : undefined}> */}
      <Boxed pad="20px">
        <PageTitle>Request Breakdown</PageTitle>
        <Boxed pad="10px 0">
          <Boxed
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="98%"
            margin="5px auto"
          >
            <Boxed
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="50%"
              position="relative"
            >
              <Text fontSize="16px" fontWeight="600">
                Sort by
              </Text>
              <AsyncSelect
                placeholder="Status"
                options={statusList?.map((item) => ({
                  label: item?.label,
                  value: item?.value,
                }))}
                {...getFieldProps("defaultReviewers", {
                  initialValue: "",
                  rules: [],
                  onChange: (val) => setStatus(val?.value),
                })}
                height="auto"
                width="150px"
              />
              <Boxed
                bColor="#F9F9F9"
                pad="11px"
                border="1px solid #ccc"
                borderRadius="5px"
              >
                <DateRangePicker
                  onChange={(val) => dateChange(val)}
                  value={value}
                />
              </Boxed>
            </Boxed>

            <Button onClick={openExportModal}>Export</Button>
          </Boxed>

          <Wrapper
            externalActionURL={fetchActionURL}
            externalParams={externalParams}
            render={({
              changePageSize,
              handlePagination,
              currentPage,
              pageSize,
              search,
            }) => {
              return (
                <>
                  <Grid
                    desktop="repeat(4, 1fr)"
                    tablet="repeat(4, 1fr)"
                    mobile="repeat(1, 1fr)"
                  ></Grid>
                  {isLoading ? (
                    <Boxed display="flex" pad="20px">
                      <Loader margin="auto" />
                    </Boxed>
                  ) : (
                    <>
                      {" "}
                      {reportListTotal > 0 ? (
                        <>
                          <TableComponent columns={columns} data={reportList} />
                          <Boxed pad="10px 0 ">
                            <PaginationComponent
                              total={reportListTotal}
                              onChange={(page) =>
                                handlePagination(page, fetchActionURL)
                              }
                              current={currentPage}
                              pageCounts={pageOptions}
                              changePageSize={(pageSize) =>
                                changePageSize(pageSize, fetchActionURL)
                              }
                              pageSize={pageSize}
                              itemsDisplayed
                              showTotal={(total, range) => {
                                return `${range[0]} - ${range[1]} of ${reportListTotal} items`;
                              }}
                            />
                          </Boxed>
                        </>
                      ) : (
                        <EmptyState />
                      )}
                    </>
                  )}
                </>
              );
            }}
          />
        </Boxed>
      </Boxed>
      {exportReportModal && <ExportReport />}
    </>
  );
};
